import { FormControl, FormControlLabel } from '@material-ui/core';
import { Close } from '@mui/icons-material';
import { Box, Button, Card, CardHeader, FormLabel, IconButton, Modal, Radio, RadioGroup } from '@mui/material'
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { CREATE_REPORT_API, REPORT_TYPES_API } from 'src/Api/Community/Index';
import { useMediaQuery } from '@mui/material';

const ReportModal = ({ modalOpen, setModalOpen, reportedItem,itemType}) => {
    const {authData}=useSelector((state)=>state.authData);
    const [reportTypes,setReportTypes]=useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [formData,setFormData]=useState({
        "reporter":authData?authData.com_userId:'',
        "reportedItem":reportedItem,
        "itemType":itemType,
        "reportType":"",
        "reason":""
    });
    const isMobile = useMediaQuery('(max-width:600px)'); 
    const handleChange=(e)=>{
        e.preventDefault();
        const {name,value} = e.target;
        setFormData({...formData,[name]:value})
    }

    const handleClose = () => {
        setModalOpen(false);
    }

    const getTypes=async()=>{
        const {data}=await REPORT_TYPES_API();
        if(data.status){
            setReportTypes(data.data);
            if(data.data.length>0){
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    reportType: data.data[0]._id
                }));
            }
        }else{
            setReportTypes([]);
        }
    }
    const handleReportSubmit=async(e)=>{
        e.preventDefault();
        if(!authData || !authData.com_userId){
            enqueueSnackbar("Please Register/Login to report the content.", {
                variant: 'error',
                anchorOrigin: { horizontal: "center", vertical: "top"}
            });
            return;
        }
        const {data}=await CREATE_REPORT_API(formData);
        if(data.status){
            enqueueSnackbar("Abuse reported successfully.", {
                variant: 'success',
                anchorOrigin: { horizontal: "center", vertical: "top"}
              });
              handleClose()
              setFormData({
                "reporter":authData?authData.com_userId:'',
                "reportedItem":"",
                "itemType":"",
                "reportType":"",
                "reason":""
              })
        }else{
            enqueueSnackbar(data.message, {
                variant: 'error',
                anchorOrigin: { horizontal: "center", vertical: "top"}
              });
              
        }
    }
    useEffect(() => {
        getTypes();
    }, [])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '90%' : 500, // Adjust the width for mobile
        maxWidth: isMobile ? '90%' : 500, // Adjust the maxWidth for mobile
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 2,
        pb: 2,
        borderRadius:"10px"
    };
    return (
        <div>
            <Modal
                open={modalOpen}
                onClose={handleClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={{ ...style }}>
                    <Box 
                    display="flex"
                    justifyContent="space-between"
                    >
                        <h3>Report</h3>
                        <Button variant='contained' color='error' size='small' onClick={handleClose}><Close/></Button>
                    </Box>
                    <Box mt={3}>
                        <form onSubmit={handleReportSubmit}>
                            <FormControl>
                                <FormLabel id="demo-radio-buttons-group-label">Please select a problem</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue={ reportTypes.length>0 ?reportTypes[0]._id:""}
                                    name="reportType"
                                    onChange={handleChange}
                                >
                                    {
                                        reportTypes.map((type)=>{
                                            return <FormControlLabel value={type._id} control={<Radio />} label={type.title} key={type._id} />
                                        })
                                    }
                                </RadioGroup>
                            </FormControl>
                            <div style={{textAlign:"right"}}>
                                <Button type='submit' variant='contained'>Submit</Button>
                            </div>
                        </form>
                    </Box>
                </Box>
            </Modal>
        </div>
    )
}

export default ReportModal